import { render } from "./BaseCard.vue?vue&type=template&id=817e87cc&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=817e87cc&scoped=true&lang=css"

import exportComponent from "D:\\Dwiki\\learn-vue\\vue-cli\\practice\\coach-vue\\coach-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817e87cc"]])

export default __exports__